import { render } from "./ProjectsPanel.vue?vue&type=template&id=3dd60874&scoped=true&ts=true"
import script from "./ProjectsPanel.vue?vue&type=script&lang=ts"
export * from "./ProjectsPanel.vue?vue&type=script&lang=ts"

import "./ProjectsPanel.vue?vue&type=style&index=0&id=3dd60874&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd60874"]])

export default __exports__